import { makeStyles } from '@material-ui/styles';

import listStyleMd from '$landing-page-raika/assets/images/list-style-image-md.png';
import bottomBackground from '$landing-page-raika/assets/images/page-solutions-obesity-study-physical-background.jpg';

export default makeStyles((theme) => ({
    root: {},
    contentWrapper: {
        '& h4': {
            ...theme.typography.h4,
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(2),
            [theme.breakpoints.down('md')]: {
                marginTop: theme.spacing(2.5),
                marginBottom: theme.spacing(1),
            },
        },
        '& h5': {
            ...theme.typography.h5,
            fontWeight: '600',
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(1),
            [theme.breakpoints.down('md')]: {
                marginTop: theme.spacing(2),
                marginBottom: theme.spacing(1),
            },
        },
        '& p': {
            ...theme.typography.body1,
            marginBottom: theme.spacing(2.5),
            [theme.breakpoints.down('md')]: {
                marginBottom: theme.spacing(1),
            },
        },
        '& ul': {
            marginLeft: theme.spacing(2),
            marginBottom: theme.spacing(2),
        },
        '& li': {
            ...theme.typography.body1,
            listStyle: 'none',
            background: `url(${listStyleMd}) no-repeat right 8px`,
            padding: theme.spacing(0, 3, 0, 0),
            '& > p': {
                marginBottom: 0,
            },
        },
    },
    sectionTwoRoot: { backgroundColor: theme.palette.logo.yellow.main, padding: theme.spacing(10, 0) },
    sectionTwoSkewBackground: {
        background: `url(${bottomBackground}) center center no-repeat`,
        backgroundSize: 'cover',
    },
}));
